import React from "react";

const PanelistCategoryRoutes = [
    {
        path: "/category/list",
        component: React.lazy(() => import("./PanelistCategoryPage"))
    }
]
export default PanelistCategoryRoutes;